import routes from '../routes/index.routes';
import { DomainMaxLossPage } from '../../pages/domain-max-loss/index/domain-max-loss.page';

export const DomainMaxLossRouter = [
	{
		path: routes.domainMaxLoss.index(),
		element: <DomainMaxLossPage />,
	},
];
